export default __webpack_public_path__ + "static/media/GS_Signature_Black.05252b67.png";